/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable max-len */
import { Form, Input, Radio, Space } from 'antd'
import { FC, useEffect, useState } from 'react'
import { CustomFormInstance } from '../../../../types'
import { MachineForm, SharedNames } from '../types'
import { ValidQuestionKeys } from '../../../../hooks/useGerateQuestions'

type Props = {
    form: CustomFormInstance<MachineForm>
    setContentBasedItemsToReview?: React.Dispatch<
        React.SetStateAction<ValidQuestionKeys[]>
    >
}

const CommunicatePatentPro: FC<Props> = ({
    form,
    setContentBasedItemsToReview,
}) => {
    const [isCommunicated, setIsCommunicated] = useState<boolean | undefined>(
        form.getFieldValue(['backgroundInvention', 'isCommunicated'])
    )
    const [isIncorporated, setIsIncorporated] = useState<boolean | undefined>(
        form.getFieldValue(['backgroundInvention', 'isIncorporated'])
    )

    useEffect(() => {
        if (!setContentBasedItemsToReview) return

        if (isCommunicated === true || isIncorporated === true) {
            setContentBasedItemsToReview((prev) => {
                if (
                    !prev.includes(
                        SharedNames.backgroundInvention as ValidQuestionKeys
                    )
                ) {
                    return [
                        ...prev,
                        SharedNames.backgroundInvention as ValidQuestionKeys,
                    ]
                }
                return prev
            })
        } else if (isCommunicated === false && isIncorporated === false) {
            setContentBasedItemsToReview((prev) =>
                prev.filter((item) => item !== SharedNames.backgroundInvention)
            )
        }
    }, [isCommunicated, isIncorporated, setContentBasedItemsToReview])

    return (
        <>
            <Form.Item
                label="Would you like to communicate with a patent professional regarding the possibility of claiming priority or incorporating a document by reference?"
                name={['backgroundInvention', 'isCommunicated']}
            >
                <Radio.Group
                    onChange={(e) => setIsCommunicated(e.target.value)}
                >
                    <Space direction="horizontal">
                        <Radio value>Yes</Radio>
                        <Radio value={false}>No</Radio>
                    </Space>
                </Radio.Group>
            </Form.Item>
            <Form.Item
                name={['backgroundInvention', 'isIncorporated']}
                label="Would you like to free-type one or more priority claims or instructions to incorporate published documents by reference into this patent application? (If you choose to discuss this application with a patent professional, the patent professional will be notified regarding this priority claim or incorporation by reference.)"
            >
                <Radio.Group
                    onChange={(e) => setIsIncorporated(e.target.value)}
                >
                    <Space direction="horizontal">
                        <Radio value>Yes</Radio>
                        <Radio value={false}>No</Radio>
                    </Space>
                </Radio.Group>
            </Form.Item>
            {isIncorporated ? (
                <Form.Item
                    name={['backgroundInvention', 'instruction']}
                    rules={[
                        {
                            required: true,
                            message: 'Field is required',
                        },
                    ]}
                    hasFeedback
                >
                    <Input type="text" />
                </Form.Item>
            ) : (
                <></>
            )}
        </>
    )
}

export default CommunicatePatentPro
